import { FormErrors } from 'KnmPackage/MainModule/types/FormErrors';
import { isAssignmentRequiredByType } from 'KnmPackage/MainModule/common/isAssignmentRequiredByType';
import { makeRequired } from 'CorePackage/MainModule/validators/isRequired';
import { REQUIRED_ERROR } from 'CorePackage/MainModule/constants/validationErrors';

import { IDecisionFormReason } from '../interfaces/IDecisionFormReason';
import { getRiskIndicatorsValidate } from './getRiskIndicatorsValidate';

export const getDecisionReasonsValidate = (
  reasons: IDecisionFormReason[] | undefined,
): FormErrors<IDecisionFormReason>[] | string | undefined => {
  return reasons?.map(item => {
    const getOrderValidate = (value: unknown) =>
      isAssignmentRequiredByType(item.type) ? makeRequired('Поле не может быть пустым')(value) : undefined;

    return {
      text: item.type?.hasText ? makeRequired('Поле не может быть пустым')(item.text) : undefined,
      date:
        !item.type?.assignmentNumberRequired && !item.type?.approveRequired && item.type?.dateRequired
          ? makeRequired('Поле не может быть пустым')(item.date)
          : undefined,
      riskIndicators: item.type?.indicatorRiskRequired
        ? getRiskIndicatorsValidate(item.riskIndicators, item.type)
        : undefined,
      requirementDetails:
        item.type?.requirementDetailsRequired || item.type?.detailsRequirement
          ? makeRequired('Поле не может быть пустым')(item.requirementDetails)
          : undefined,
      dateRequirement: item.type?.dateRequirement
        ? makeRequired('Поле не может быть пустым')(item.dateRequirement)
        : undefined,
      order: getOrderValidate(item.order),
      assignmentDate: item.order ? makeRequired(REQUIRED_ERROR)(item.assignmentDate) : undefined,
      assignmentNumber: item.order ? makeRequired(REQUIRED_ERROR)(item.assignmentNumber) : undefined,
      fullName: item.order ? makeRequired(REQUIRED_ERROR)(item.fullName) : undefined,
      programNumber: item.type?.programNumberRequired
        ? makeRequired('Поле не может быть пустым')(item.programNumber)
        : undefined,
      programAttachment: item.type?.programFileRequired
        ? makeRequired('Поле не может быть пустым')(item.programAttachment)
        : undefined,
      prosecutorAttachment: item.type?.prosecutorAttachmentRequired
        ? makeRequired('Поле не может быть пустым')(item.prosecutorAttachment)
        : undefined,
      prescriptionDate: item.type?.prescriptionDateRequired
        ? makeRequired('Поле не может быть пустым')(item.prescriptionDate)
        : undefined,
      prescriptionNumber: item.type?.prescriptionNumberRequired
        ? makeRequired('Поле не может быть пустым')(item.prescriptionNumber)
        : undefined,
    };
  });
};
